import { Directive, HostListener } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';

@Directive({
  selector: '[hrefExternalUrl]'
})
export class HrefExternalUrlDirective {
  private static readonly HTTP_TEST_REGEX = /^http[s]?:\/\//;

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    let url: string = (<any>event.currentTarget).getAttribute('href');

    if (
      !StringHelper.isEmptyOrWhiteSpace(url) &&
      !HrefExternalUrlDirective.HTTP_TEST_REGEX.test(url)
    ) {
      url = `//${url}`;
    }

    window.open(url, '_blank');
  }
}
